// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"cd3a218e","543":"cfc9ad3f","961":"22a94d92"}[chunkId] + ".css";
};